<template>
    <div class="page page_video_play">
        <!-- <div class="tradesmanInfo" v-if="videoDetail != null">
        <div class="attention_status_btn" @click="attention">{{ videoDetail.attention_status == null ? '关注' : '已关注' }}</div>
        <img class="thumb" :src="
                    videoDetail != null && videoDetail.tradesman.thumb != null && videoDetail.tradesman.thumb != ''
                        ? videoDetail.tradesman.thumb
                        : $publicData.defaultTouxiang
                " />
        <div class="tInfos">
            <p class="tradesmanName">{{ videoDetail.tradesman.nickname }}</p>
            <p class="livingNum">{{ videoDetail.count }}人在线</p>
        </div>
    </div> -->
        
        <div class="prism-player video_play" :id="playerId" :style="playStyle"></div>
        <div class="living_tabs">
            <div class="video_play_title">视频详情</div>
            <div class="describe_tab">
                <div class="tab_content">
                    <h3 class="tab_content_title" v-if="videoDetail != null && videoDetail.list.liveroom != null">{{ videoDetail.list.liveroom.title }}</h3>
                    <div class="living_describe" v-if="videoDetail != null && videoDetail.list.liveroom != null" v-html="videoDetail.list.liveroom.describe"></div>
                </div>
            </div>
            <!-- <van-tabs class="living_vantab" v-model="tabActive" line-width=".7rem">
                <van-tab title="直播介绍" name="describe">
                    <div class="tab_content">
                        <div class="living_describe" v-if="videoDetail.list.liveroom != null" v-html="videoDetail.list.liveroom.describe"></div>
                    </div>
                </van-tab>
            </van-tabs> -->
            <!-- <div class="socket_fix_bottom">
            <div class="fix_bottom_send_msg">
                <button type="button" class="send_btn" @click="sendMsg">发送</button>
                <input type="text" placeholder="互动留言~" v-model="msg" class="send_ipt" @keypress="checkMsg" @blur="resetWindow" confirm-type='send' />
            </div>
        </div> -->
        </div>
    </div>
</template>

<script>
    import router from '../../../.././router';
    import {
        LOGOUT,
        LOGIN
    } from '../../../.././vuex/mutation_types';
    import PageSearch from '../../../component/search/Index.vue';
    import Vue from 'vue';
    import Bridge from '../../../.././vuex/bridge.js';
    Vue.prototype.$bridge = Bridge;
    var userAgent = navigator.userAgent;

    export default {
        data() {
            return {
				imageUrl: this.$publicData.uploadImage,
                isClient: false,
                token: null,
                playerId: 'aliplayer_' +
                    Math.random()
                        .toString(36)
                        .substr(2),
                instance: null,
                videoDetail: null,
                playStyle: {
                    height: '40vh',
                    display: 'none'
                },
                tabActive: 'interaction',
                player: null,   // 初始化的播放器
            };
        },
        created() {

        },
        watch: {
            'window.scroll': function (n, o) {
                console.log(n);
            }
        },
        mounted() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                this.isClient = true
                var params = {
                    data: {
                        // naviBlackStyle: true,
                        naviTitle: "视频播放",
                        // levitate: true
                    },
                };
                this.$bridge.callhandler('sdjy://navigation/style', params, data => { });
                //获取用户信息
                var memberParams = {
                    data: {
                        'notCallLogin': 1,
                        // 'forceLogin': 1,
                    }
                };
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, data => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = '';
                    }
                    this.getVideoDetail();
                });
                //注册方法，客户端重新进入页面刷新数据
                this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                });
                // var that = this
                // //注册方法，客户端重新进入页面刷新数据
                // this.$bridge.registerhandler('sdjy://common/leftButtonAction', (data, responseCallback) => {
                //     // alert('sdjy://common/leftButtonAction');
                //     that.player.pause();
                //     // alert(JSON.stringify(data));
                //     responseCallback(data);
                // });
            } else {
                this.isClient = false
                this.token = this.$store.getters.token;
                this.getVideoDetail();
                // let that = this;
                // document.body.addEventListener(
                //     'touchmove',
                //     function (ev) {
                //         if (that.$route.name == 'video-play') {
                //             ev.preventDefault();
                //         }
                //     }, {
                //         passive: false
                //     }
                // );
                // $("body").on('touchmove',function(ev) {
                //     ev.preventDefault();
                // })
                // this.getShareData()
            }
        },
        methods: {
            getVideoDetail() {
                this.$api.living.posvideoDetail({
                    token: this.token,
                    id: this.$route.query.id
                }).then(res => {
                    console.log(res);
                    if (res.code == 200) {
                        this.videoDetail = res.result;
                        this.getShareData()
                        // 初始化播放器
                        this.setPlayer();
                    }
                });
            },
            // 播放器
            setPlayer() {
                var that = this
                console.log(that.videoDetail)
                // if ( that.videoDetail.list.url != '' && that.videoDetail.list.url != null ){
                //     return;
                // }
                console.log('111')
                that.playStyle.display = 'block';
                that.instance = new Aliplayer({
                    id: that.playerId,
                    source: that.videoDetail.list.url,
                    width: '100%',
                    height: that.playStyle.height,
                    autoplay: true,
                    isLive: false,
                    rePlay: false,
                    playsinline: true,
                    preload: true,
                    controlBarVisibility: "hover",
                    useH5Prism: true,
                    skinLayout: [
                        {
                            name: "bigPlayButton",
                            align: "blabs",
                            x: 30,
                            y: 80
                        },
                        {
                            name: "H5Loading",
                            align: "cc"
                        },
                        {
                            name: "infoDisplay"
                        },
                        {
                            name: "tooltip",
                            align: "blabs",
                            x: 0,
                            y: 56
                        },
                        {
                            name: "thumbnail"
                        },
                        {
                            name: "controlBar",
                            align: "blabs",
                            x: 0,
                            y: 0,
                            "children": [
                                {
                                    "name": "progress",
                                    "align": "blabs",
                                    "x": 0,
                                    "y": 44
                                },
                                {
                                    "name": "playButton",
                                    "align": "tl",
                                    "x": 15,
                                    "y": 12
                                },
                                {
                                    "name": "timeDisplay",
                                    "align": "tl",
                                    "x": 10,
                                    "y": 7
                                },
                                {
                                    "name": "fullScreenButton",
                                    "align": "tr",
                                    "x": 10,
                                    "y": 12
                                },
                                {
                                    "name": "volume",
                                    "align": "tr",
                                    "x": 5,
                                    "y": 10
                                }
                            ]
                        }
                    ],
                    x5LandscapeAsFullScreen: false,
                    // x5_type:'h5',
                    showBarTime: 5000,
                    controlBarVisibility: "always",
                    x5_fullscreen: true,
                    x5_video_position: "top",
                    // "x5_orientation":"landscape",
                },
                    function (player) {
                        that.player = player;
                        console.log('The player is created');
                        // $('.prism-volume').before("<i class='control_btn'></i>");
                        $("video").attr('x5-video-player-type', 'h5');
                        // $('.control_btn').on('click', function () {
                        //     if (!$('.prism-player').hasClass('fullScreen')) {
                        //         $('.prism-player').addClass('fullScreen');
                        //         $('.living_tabs').addClass('fullScreen');
                        //     } else {
                        //         $('.prism-player').removeClass('fullScreen');
                        //         $('.living_tabs').removeClass('fullScreen');
                        //     }
                        // });
                        player.on("error", function (e) {
                            $(".prism-ErrorMessage").hide();
                            player.show_video = true;
                        });
                        
                    // player.setPreviewTime(1); //	time试看时间	设置试看时间，单位为秒，详情参见试看
                    // player.getPreviewTime, //		获取试看时间
                    // isPreview		是否试看
                    }
                );
                // this.playStyle.height="100vh";
            },
            msgTouchStart(e) {
                // console.log('touchstart',e.changedTouches[0]);
                this.startTouch = e.changedTouches[0].pageY;
                this.isTouch = true;
            },
            msgTouchEnd() {
                // console.log('touchend');
                this.isTouch = false;
            },
            msgTouchMove(e) {
                let y = e.changedTouches[0].pageY;
                if ($('.living_tabs').hasClass('fullScreen')) {
                    let msgT = $('#msgList1').scrollTop();
                    let listScroll = msgT - (y - this.startTouch); // * (window.screen.width / 750);
                    this.startTouch = y;
                    // console.log('move',y,msgT,listScroll,this.startTouch);
                    $('#msgList1').scrollTop(listScroll);
                } else {
                    let msgT = $('#msgList2').scrollTop();
                    let listScroll = msgT - (y - this.startTouch); // * (window.screen.width / 750);
                    this.startTouch = y;
                    // console.log('move',y,msgT,listScroll,this.startTouch);
                    $('#msgList2').scrollTop(listScroll);
                }
            },
            msgScroll(e, y) {
                // console.log('滚动了', e.target.scrollTop, e.target.offsetHeight);
                let lH = 0;
                if ($('.living_tabs').hasClass('fullScreen')) {
                    lH = $('#msgList1 .interaction_content').height();
                } else {
                    lH = $('#msgList2 .interaction_content').height();
                }
                // console.log('msgList:', lH);
                if (e.target.scrollTop + e.target.offsetHeight <= lH - 40) {
                    this.goBottom = false;
                } else {
                    this.goBottom = true;
                }

                // if ($('.living_tabs').hasClass('fullScreen')) {
                //     if ($('#msgList1 .i_item').length > 3) {
                //         setTimeout(function() {
                //             var len = 0;
                //             $('#msgList1 .i_item').each(function(i) {
                //                 console.log(i, $(this).position().top, $(this).position().top > 0);
                //                 $(this).css({
                //                     opacity: 1
                //                 });
                //                 if ($(this).position().top >= 0) {
                //                     $(this).css({
                //                         opacity: 1 - (10 - len * 3) / 10
                //                     });
                //                     len++;
                //                 } else {
                //                     $(this).css({
                //                         opacity: 0
                //                     });
                //                 }
                //             });
                //         }, 0);
                //     }
                // }
            },
            // 失去焦点时也没高度回弹
            resetWindow() {
                // $(window).scrollTop(0);
                window.scrollTo(-1, 1);
            },
            // 获取分享参数 -- 用于配微信分享
            getShareData() {
                const url = location.href.split('#')[0];
                this.$api.index.commonShare({
                    url: url
                }).then(res => {
                    if (res.code == 200) {
                        var data = res.result
                        this.shareConfig = data
                        console.log('this.shareConfig', this.shareConfig)
                        console.log('this.$route', this.$route)
                        this.shareFun()
                    }
                })
            },
            // 分享
            shareFun() {
                var that = this
                // console.log('11111111111111')
                wx.config({
                    debug: that.shareConfig.debug,
                    beta: that.shareConfig.beta,
                    jsApiList: that.shareConfig.jsApiList,
                    appId: that.shareConfig.appId,
                    nonceStr: that.shareConfig.nonceStr, // 随机串
                    timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                    signature: that.shareConfig.signature, // 签名
                });
                // console.log('222222222222')
                // console.log('that.videoDetail+1111',that.videoDetail)
                // 分享
                wx.ready(function () {
                    const url = location.href.split('#')[0];
                    console.log('url', url)
                    console.log('that.videoDetail', that.videoDetail)
                    var shareData = {
                        title: that.videoDetail.title, // 分享标题
                        desc: that.videoDetail.describe, // 分享描述
                        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: that.imageUrl + that.videoDetail.thumb, // 分享图标
                        success: function () {
                            // 用户确认分享后执行的回调函数
                            // alert('成功')
                            // console.log('success')
                        },
                        cancel: function (e) {
                            // console.log('e',e)
                            // 用户取消分享后执行的回调函数
                        }
                    }

                    wx.updateAppMessageShareData(shareData);
                    wx.updateTimelineShareData(shareData);
                });
            }
        }
    };
</script>

<style lang="postcss" scoped>
    @import 'https://g.alicdn.com/de/prismplayer/2.7.2/skins/default/aliplayer-min.css';
</style>